import React, { useEffect, useState } from "react";

function TourneyDetailsPrizeStructure({ selectedTourneyDetails }) {
  const { groupPayoutSlabRanges = {} } = selectedTourneyDetails;
  // const [keysOfOrigionalArray, setKeysOfOrigionalArray] = useState([...Object.keys(original)])
  const [keysOfOrigionalArray, setKeysOfOrigionalArray] = useState([
    ...Object.keys(groupPayoutSlabRanges),
  ]);
  const [splittedKeysArr, setSplittedKeysArr] = useState([]);

  useEffect(() => {
    if (
      Object.keys(groupPayoutSlabRanges).length > 0 &&
      splittedKeysArr?.length == 0
    ) {
      splitArr([...keysOfOrigionalArray], 5);
    }
  }, [groupPayoutSlabRanges]);

  const splitArr = (array, groupSize) => {
    const result = [];
    for (let i = 0; i < array.length; i += groupSize) {
      result.push([...array.slice(i, i + groupSize)]);
    }

    setSplittedKeysArr(result);
    return result;
  };

  return (
    <div>
      {Object.keys(groupPayoutSlabRanges).length > 0 ? (
        splittedKeysArr.map((groupedKeys, groupedIndex) => {
          return (
            <div key={groupedIndex} className={``}>
              <div className="flex items-center justify-start py-2 px-1 mb-2 text-secondary text-xs">
                <div className="w-1/6 text-center ">RANK</div>
                {groupedKeys?.map((keys, index) => (
                  <div key={index} className="w-1/6 text-center break-all">
                    {keys?.replace("_", "-") || ""}
                  </div>
                ))}
              </div>
              {Object.keys(
                groupPayoutSlabRanges?.[groupedKeys.slice(-1)] || {}
              ).map((item, innerIndex) => (
                <div
                  key={item}
                  className="flex items-center justify-center py-2 px-1 mb-2 bg-linear-to-r from-surface/20 to-accent/20 rounded-200 overflow-hidden font-medium text-sm text-primary"
                >
                  <div className="w-1/6 text-center ">{item}</div>
                  <div className="w-1/6 text-center  ">
                    {groupPayoutSlabRanges?.[groupedKeys[0]]?.[item] || ""}
                  </div>
                  <div className="w-1/6 text-center  ">
                    {groupPayoutSlabRanges?.[groupedKeys[1]]?.[item] || ""}
                  </div>
                  <div className="w-1/6 text-center  ">
                    {groupPayoutSlabRanges?.[groupedKeys[2]]?.[item] || ""}
                  </div>
                  <div className="w-1/6 text-center  ">
                    {groupPayoutSlabRanges?.[groupedKeys[3]]?.[item] || ""}
                  </div>
                  <div className="w-1/6 text-center  ">
                    {groupPayoutSlabRanges?.[groupedKeys[4]]?.[item] || ""}
                  </div>
                </div>
              ))}
            </div>
          );
        })
      ) : (
        <div className="py-4 flex items-center justify-center text-sm text-primary font-medium">
          Prize Structure not available
        </div>
      )}
    </div>
  );
}

export default TourneyDetailsPrizeStructure;

const original = {
  "0_13": {
    "1-1": 5500,
    "2-2": 3000,
    "3-3": 1500,
  },
  "14_21": {
    "1-1": 5000,
    "2-2": 2600,
    "3-3": 1300,
    "4-4": 1100,
  },
  "22_27": {
    "1-1": 4500,
    "2-2": 2400,
    "3-3": 1200,
    "4-4": 1000,
    "5-5": 900,
  },
  "28_33": {
    "1-1": 4200,
    "2-2": 2200,
    "3-3": 1100,
    "4-4": 900,
    "5-5": 850,
    "6-6": 750,
  },
  "34_39": {
    "1-1": 3900,
    "2-2": 2050,
    "3-3": 1050,
    "4-4": 850,
    "5-5": 800,
    "6-6": 700,
    "7-7": 650,
  },
  "40_47": {
    "1-1": 3700,
    "2-2": 1950,
    "3-3": 1000,
    "4-4": 800,
    "5-5": 750,
    "6-6": 650,
    "7-7": 600,
    "8-8": 550,
  },
  "48_59": {
    "1-1": 3400,
    "2-2": 1650,
    "3-3": 950,
    "4-4": 750,
    "5-5": 700,
    "6-6": 600,
    "7-7": 550,
    "8-9": 500,
    "10-10": 400,
  },
  "60_70": {
    "1-1": 3000,
    "2-2": 1400,
    "3-3": 900,
    "4-4": 700,
    "5-5": 650,
    "6-6": 550,
    "7-7": 500,
    "8-8": 450,
    "9-9": 400,
    "10-10": 350,
    "11-12": 300,
    "13-14": 250,
  },
  "71_90": {
    "1-1": 5000,
    "2-2": 1500,
    "3-3": 800,
    "4-4": 400,
    "5-5": 200,
    "6-10": 140,
    "11-20": 80,
    "21-30": 60,
  },
  "91_100000": {
    "1-1": 7000,
    "2-2": 1500,
    "3-3": 800,
    "4-4": 400,
    "5-5": 200,
    "6-10": 140,
    "11-20": 80,
    "21-30": 60,
  },
};
